import { useEffect, useRef, useCallback } from "react";
import useStores from "../../hooks/use-stores";
import { IsAuthed } from "../../utilities/general";

export const VersionProvider = ({ children }: { children: any }) => {
  const { userStore } = useStores();
  const lastCheckRef = useRef(0);
  const inFlightRef = useRef(false);

  const checkVersion = useCallback(async () => {
    if (!IsAuthed()) return;
    if (document.visibilityState !== "visible") return;
    if (inFlightRef.current) return;

    const now = Date.now();
    if (now - lastCheckRef.current < 2 * 60_000) return;

    try {
      inFlightRef.current = true;
      await userStore.getVersion();
      lastCheckRef.current = now;
    } finally {
      inFlightRef.current = false;
    }
  }, []);

  useEffect(() => {
    checkVersion();

    const onVisibility = () => {
      if (document.visibilityState === "visible") checkVersion();
    };

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", checkVersion);
    const interval = window.setInterval(checkVersion, 30 * 60_000);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", checkVersion);
      window.clearInterval(interval);
    };
  }, [checkVersion]);

  return children;
};